import DataForm from '@/core/work-components/data-form';
export default {
  name: 'QuickSearch',
  components: {
    DataForm
  },

  data() {
    return {};
  },

  props: {
    controls: Array,
    value: {
      type: String,
      default: ''
    },
    formValue: {
      type: Object,
      default: () => ({})
    },
    adv: Boolean,
    // 是否支持高级搜索
    labelWidth: String,
    // 表单的标签宽度
    labelPosition: String // 表单的标签对齐方式

  },
  computed: {
    keyword: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit('input', val);
      }

    },

    commonControls() {
      return (this.controls || []).filter(item => !item.xtype);
    },

    formControls() {
      return (this.controls || []).filter(item => item.xtype);
    },

    formSchema() {
      return {
        title: '',
        labelPosition: this.labelPosition,
        labelWidth: this.labelWidth,
        size: 'small',
        children: this.formControls.map(item => {
          const newItem = { ...item,
            options: { ...item.options
            }
          }; // data-from添加了下拉多选的支持，高级搜索也放开

          if (newItem.xtype === 'multi-select2') {
            newItem.xtype = 'select-multiple';
          }

          return newItem;
        })
      };
    },

    placeholader() {
      const words = this.commonControls.map(item => item.options.label).join('/');
      return `请输入${words}`;
    },

    buttonStyle() {
      return {
        borderColor: '#409EFF',
        color: '#f5f5f5',
        borderTopWidth: '1px',
        borderTopStyle: 'solid',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderRightWidth: '1px',
        borderRightStyle: 'solid',
        backgroundColor: '#409EFF',
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      };
    }

  },
  methods: {
    handleFormChange(value) {
      this.$emit('form-input', value);
    },

    doSearch() {
      this.$emit('search');
    },

    close() {
      this.$emit('close');
    }

  }
};